import "./OurSolutions.module.css";
import Header from "@/reusable_sections/Header";
import OurSpecializedSolutions from "./sections/OurSpecializedSolutions";
import OurProfessionalPromise from "./sections/OurProfessionalPromise";
import Footer from "@/reusable_sections/Footer";
export default function OurSolutionsPage() {
  return <div>
      <Header />
      <OurSpecializedSolutions />
      <OurProfessionalPromise />
      <Footer />
    </div>;
}